import { PlatformEntity } from '@provision/entity-types';
import type { KeyboardEvent } from 'react';
import { FormTextField } from 'src/components/Forms';

export interface CustomAttributeGroupFormValues {
  editCustomAttributeGroup?: string;
}

export const CustomAttributeGroupForm = ({
  entity,
  onSubmit,
  index,
  partnerId,
}: {
  onSubmit: (value: string) => void;
  entity?: PlatformEntity;
  partnerId: number;
  index: number;
}) => {
  const handleKeyDown = (event: KeyboardEvent) => {
    if (['Enter', 'Escape'].includes(event.key)) {
      event.stopPropagation();
      event.preventDefault();
      onSubmit((event.target as HTMLInputElement).value);
    }
  };

  return (
    <FormTextField
      type="textfield"
      name={`${entity?.id!}.${partnerId}.${index}.displayName`}
      label="Group name"
      required
      sx={{ marginTop: 2 }}
      textFieldProps={{
        autoFocus: true,
        onKeyDown: handleKeyDown,
        inputProps: {
          'data-testid': 'custom-attribute-group-name-input',
          onBlur: ({ target }: { target: EventTarget }) => {
            onSubmit((target as HTMLInputElement).value);
          },
        },
      }}
    />
  );
};
